<template>
	<view class="box" v-if="info">
		<view class="box_head">
			<view class="box_head_info">
				<view class="status info">{{info.statusName}}</view>
				<view class="box_head_info_title">出险人：{{info.memberName || ''}}</view>
				<view class="box_head_info_list">
					<view class="box_head_info_list_item">
						<view class="label">身份证号：</view>
						<view class="value">{{info.memberIdcardNo}}</view>
					</view>
					<view class="box_head_info_list_item">
						<view class="label">保险方案：</view>
						<view class="value">{{info.solutionName}}</view>
					</view>
					<view class="box_head_info_list_item">
						<view class="label">所属工种：</view>
						<view class="value">{{info.worktypeName}}</view>
					</view>
					<view class="box_head_info_list_item">
						<view class="label">报案人：</view>
						<view class="value">{{info.informantName}}</view>
					</view>
					<view class="box_head_info_list_item">
						<view class="label">报案人联系方式：</view>
						<view class="value">{{info.informantPhone}}</view>
					</view>
				</view>
			</view>
			<!-- 已打款 -->
			<view class="box_dakuan" v-if="[13].includes(info.status)">
				<view class="box_dakuan_head">
					<image src="/static/icon/ic_yiqueren@2x.png" mode="widthFix"></image>
					<text>已打款</text>
				</view>
				<view class="box_dakuan_list">
					<view class="box_dakuan_list_row">
						<view class="box_dakuan_list_row_label">打款时间</view>
						<view class="box_dakuan_list_row_val">{{info.refuseSettleClaimsLog.createDate}}</view>
					</view>
					<view class="box_dakuan_list_row">
						<view class="box_dakuan_list_row_label">打款说明</view>
						<view class="box_dakuan_list_row_val">{{info.refuseSettleClaimsLog.content}}</view>
					</view>
					<view class="box_dakuan_list_row">
						<view class="box_dakuan_list_row_label">打款凭证</view>
						<view class="box_dakuan_list_row_list" v-if="info.payFileList">
							<view class="box_dakuan_list_row_list_image" v-for="(item, index) in info.payFileList" :key="index">
								<image :src="item.fileurlFull" mode="widthFix"></image>
							</view>
						</view>
					</view>
				</view>
			</view>
			<view class="box_jine" v-if="[11,12,13].includes(info.status)">
				<view class="box_jine_head">
					<image src="/static/icon/ic_daiqueren@2x.png" mode="widthFix" v-if="[11].includes(info.status) && info.feeUpdate === 0"></image>
					<image src="/static/icon/ic_yiqueren@2x.png" mode="widthFix" v-else></image>
					<text v-if="[11].includes(info.status) && info.feeUpdate === 1">赔付金额已变更</text>
					<text v-else-if="[11].includes(info.status) && info.feeUpdate === 0">赔付金额待确认</text>
					<text v-else>赔付金额已确认</text>
				</view>
				<view class="box_jine_nr">
					<view class="box_jine_nr_head">
						<image src="/static/icon/ic_t1ips@2x.png" mode="widthFix"></image>
						<text>重要提示</text>
					</view>
					<view class="box_jine_nr_list">
						<text>· 赔付款项将在确认后 1-3 个工作日内到账</text>
						<text>· 请确认收款账户信息准确无误</text>
						<text>· 如有疑问请及时联系客服 <text style="color: #FF971D;">0551-77738493</text></text>
					</view>
				</view>
				<view class="box_jine_price">¥ {{info.hpAccount + info.hpOtherAccount}}</view>
				<view class="box_jine_pf" @click="jumpD">
					<text>查看赔付详情</text>
					<u-icon name="arrow-right" color="#437CB3" size="16"></u-icon>
				</view>
				<view class="box_jine_x" v-if="[11].includes(info.status)"></view>
				<view class="box_jine_submit" @click="queren" v-if="[11].includes(info.status)">确认金额无误</view>
			</view>
			<view class="box_tuihui" v-if="[10,11,12].includes(info.status)">
				<view class="box_tuihui_label">
					收款账户信息确认
					<text>修改</text>
				</view>
				<view class="box_tuihui_list">
					<view class="box_tuihui_list_row">
						<view class="box_tuihui_list_row_label">开户银行</view>
						<view class="box_tuihui_list_row_val">{{info.receiveBank}}</view>
					</view>
					<view class="box_tuihui_list_row">
						<view class="box_tuihui_list_row_label">账号</view>
						<view class="box_tuihui_list_row_val">{{info.receiveAccount}}</view>
					</view>
					<view class="box_tuihui_list_row">
						<view class="box_tuihui_list_row_label">户名</view>
						<view class="box_tuihui_list_row_val">{{info.receiveUserName}}</view>
					</view>
				</view>
			</view>
			<view class="box_tuihui" v-if="[9].includes(info.status) && info.waitSupplement === 1">
				<view class="box_tuihui_label">材料补充</view>
				<view class="box_tuihui_list">
					<view class="box_tuihui_list_row">
						<view class="box_tuihui_list_row_label">补充说明</view>
						<view class="box_tuihui_list_row_val" style="color: #FF0000;">{{info.refuseSettleClaimsLog.content}}</view>
					</view>
					<view class="box_tuihui_list_row">
						<view class="box_tuihui_list_row_label">理赔人员</view>
						<view class="box_tuihui_list_row_val">{{info.refuseSettleClaimsLog.creatorName}}</view>
					</view>
					<view class="box_tuihui_list_row">
						<view class="box_tuihui_list_row_label">退回时间</view>
						<view class="box_tuihui_list_row_val">{{info.refuseSettleClaimsLog.createDate}}</view>
					</view>
				</view>
			</view>
			<view class="box_tuihui" v-if="[6,8].includes(info.status)">
				<view class="box_tuihui_label">拒绝说明</view>
				<view class="box_tuihui_list">
					<view class="box_tuihui_list_row">
						<view class="box_tuihui_list_row_label">拒绝说明</view>
						<view class="box_tuihui_list_row_val" style="color: #FF0000;">{{info.refuseSettleClaimsLog.content}}</view>
					</view>
					<view class="box_tuihui_list_row">
						<view class="box_tuihui_list_row_label">理赔人员</view>
						<view class="box_tuihui_list_row_val">{{info.refuseSettleClaimsLog.creatorName}}</view>
					</view>
					<view class="box_tuihui_list_row">
						<view class="box_tuihui_list_row_label">拒绝时间</view>
						<view class="box_tuihui_list_row_val">{{info.refuseSettleClaimsLog.createDate}}</view>
					</view>
				</view>
			</view>
			<view class="box_tuihui" v-if="[4].includes(info.status)">
				<view class="box_tuihui_label">退回说明</view>
				<view class="box_tuihui_list">
					<view class="box_tuihui_list_row">
						<view class="box_tuihui_list_row_label">退回说明</view>
						<view class="box_tuihui_list_row_val" style="color: #FF0000;">{{info.refuseSettleClaimsLog.content}}</view>
					</view>
					<view class="box_tuihui_list_row">
						<view class="box_tuihui_list_row_label">理赔人员</view>
						<view class="box_tuihui_list_row_val">{{info.refuseSettleClaimsLog.creatorName}}</view>
					</view>
					<view class="box_tuihui_list_row">
						<view class="box_tuihui_list_row_label">退回时间</view>
						<view class="box_tuihui_list_row_val">{{info.refuseSettleClaimsLog.createDate}}</view>
					</view>
				</view>
			</view>
			<view class="box_head_infoA" :style="{ height: height }">
				<view class="box_head_info_title" @click="open(1)">
					<view class="title">事故信息</view>
					<view class="rowwle">
						<text>{{height === 'auto' ? '收起' : '展开'}}</text>
						<image :style="{transform: height === 'auto' ? '' : 'rotate(180deg)'}" src="@/static/icon/ic_close@2x.png" mode="widthFix"></image>
					</view>
				</view>
				<view class="info_list">
					<view class="info_list_item">
						<view class="info_list_item_label">报案号</view>
						<view class="info_list_item_val">{{info.reportNum || '-'}}</view>
					</view>
					<view class="info_list_item">
						<view class="info_list_item_label">事故类型</view>
						<view class="info_list_item_val" v-if="info.type === 0">工作期间受伤</view>
						<view class="info_list_item_val" v-if="info.type === 1">上下班途中受伤</view>
						<view class="info_list_item_val" v-if="info.type === 2">非工作时间受伤</view>
						<view class="info_list_item_val" v-if="info.type === 3">意外受伤</view>
					</view>
					<view class="info_list_item">
						<view class="info_list_item_label">出险时间</view>
						<view class="info_list_item_val">{{info.happenTime}}</view>
					</view>
					<view class="info_list_item">
						<view class="info_list_item_label">出险地区</view>
						<view class="info_list_item_val">{{info.areaInfo}}</view>
					</view>
					<view class="info_list_item">
						<view class="info_list_item_label">出险经过</view>
						<view class="info_list_item_val">{{info.content}}</view>
					</view>
					<view class="info_list_item">
						<view class="info_list_item_label">就诊医疗机构</view>
						<view class="info_list_item_val">{{info.hospital || '-'}}</view>
					</view>
					<view class="info_list_item">
						<view class="info_list_item_label">就诊类型</view>
						<view class="info_list_item_val">{{returnInHospital(info.inHospital)}}</view>
					</view>
					<view class="info_list_item">
						<view class="info_list_item_label">是否伤残</view>
						<view class="info_list_item_val">{{returnName(info.hurtType)}}</view>
					</view>
					<view class="info_list_item">
						<view class="info_list_item_label">是否有医疗保险</view>
						<view class="info_list_item_val">{{returnName(info.medicalInsurance)}}</view>
					</view>
					<view class="info_list_item f">
						<view class="info_list_item_label1">事故视频/照片</view>
						<view class="info_list_item_tu" v-if="info && info.reportFileList">
							<view class="info_list_item_tu_img" v-for="(item, index) in info.reportFileList" :key="index">
								<image :src="item.fileurlFull" mode="widthFix" v-if="item.type === 0"></image>
								<video src="item.fileurlFull" v-if="item.type === 1"></video>
							</view>
							<view class="info_list_item_tu_zw"></view>
							<view class="info_list_item_tu_zw"></view>
							<view class="info_list_item_tu_zw"></view>
						</view>
					</view>
				</view>
			</view>
			<view class="box_head_infoA" :style="{ height: height1 }">
				<view class="box_head_info_title" @click="open(2)">
					<view class="title">理赔资料</view>
					<view class="rowwle">
						<text>{{height1 === 'auto' ? '收起' : '展开'}}</text>
						<image :style="{transform: height1 === 'auto' ? '' : 'rotate(180deg)'}" src="@/static/icon/ic_close@2x.png" mode="widthFix"></image>
					</view>
				</view>
				<view class="info_list">
					<view class="info_list_item f">
						<view class="info_list_item_label1">员工关系证明资料</view>
						<view class="info_list_item_tu" v-if="info">
							<view class="info_list_item_tu_img" v-for="(item,index) in info.relationFileList" :key="index">
								<!-- <view class="info_list_item_tu_img_dele" @click.stop="deleFile(item.id, item.objId)">
									<image src="@/static/icon/ic_delete@2x.png" mode="widthFix"></image>
								</view> -->
								<image :src="item.fileurlFull" mode="widthFix" v-if="item.type == 0"></image>
								<video :src="item.fileurlFull" v-if="item.type == 1" />
							</view>
							<view class="info_list_item_tu_up" @click="upload(2)" v-if="info.status == 0 || info.status == 2 || info.status == 3">
								<u-icon name="plus" color="#222222" size="20"></u-icon>
							</view>
							<view class="info_list_item_tu_zw"></view>
							<view class="info_list_item_tu_zw"></view>
							<view class="info_list_item_tu_zw"></view>
						</view>
					</view>
					<view class="info_list_item f">
						<view class="info_list_item_label1">门诊</view>
						<view class="info_list_item_tu" v-if="info">
							<view class="info_list_item_tu_img" v-for="(item, index) in info.outpatientFileList" :key="index">
								<!-- <view class="info_list_item_tu_img_dele" @click.stop="deleFile(item.id, item.objId)">
									<image src="@/static/icon/ic_delete@2x.png" mode="widthFix"></image>
								</view> -->
								<image :src="item.fileurlFull" mode="widthFix" v-if="item.type === 0"></image>
								<video :src="item.fileurlFull" v-if="item.type === 1"></video>
							</view> 
							<view class="info_list_item_tu_up" @click="upload(3)" v-if="info.status == 0 || info.status == 2 || info.status == 3">
								<u-icon name="plus" color="#222222" size="20"></u-icon>
							</view>
							<view class="info_list_item_tu_zw"></view>
							<view class="info_list_item_tu_zw"></view>
							<view class="info_list_item_tu_zw"></view>
						</view>
					</view>
					<view class="info_list_item f">
						<view class="info_list_item_label1">住院</view>
						<view class="info_list_item_tu" v-if="info">
							<view class="info_list_item_tu_img" v-for="(item, index) in info.hospitalFileList" :key="index">
								<!-- <view class="info_list_item_tu_img_dele" @click.stop="deleFile(item.id, item.objId)">
									<image src="@/static/icon/ic_delete@2x.png" mode="widthFix"></image>
								</view> -->
								<image :src="item.fileurlFull" mode="widthFix" v-if="item.type === 0"></image>
								<video :src="item.fileurlFull" v-if="item.type === 1"></video>
							</view>
							<view class="info_list_item_tu_up" @click="upload(6)" v-if="info.status == 0 || info.status == 2 || info.status == 3">
								<u-icon name="plus" color="#222222" size="20"></u-icon>
							</view>
							<view class="info_list_item_tu_zw"></view>
							<view class="info_list_item_tu_zw"></view>
							<view class="info_list_item_tu_zw"></view>
						</view>
					</view>
					<view class="info_list_item f">
						<view class="info_list_item_label1">伤残</view>
						<view class="info_list_item_tu" v-if="info">
							<view class="info_list_item_tu_img" v-for="(item, index) in info.disabilityFileList" :key="index">
								<!-- <view class="info_list_item_tu_img_dele" @click.stop="deleFile(item.id, item.objId)">
									<image src="@/static/icon/ic_delete@2x.png" mode="widthFix"></image>
								</view> -->
								<image :src="item.fileurlFull" mode="widthFix" v-if="item.type === 0"></image>
								<video :src="item.fileurlFull" v-if="item.type === 1"></video>
							</view>
							<view class="info_list_item_tu_up" @click="upload(6)" v-if="info.status == 0 || info.status == 2 || info.status == 3">
								<u-icon name="plus" color="#222222" size="20"></u-icon>
							</view>
							<view class="info_list_item_tu_zw"></view>
							<view class="info_list_item_tu_zw"></view>
							<view class="info_list_item_tu_zw"></view>
						</view>
					</view>
					<view class="info_list_item f">
						<view class="info_list_item_label1">其他材料</view>
						<view class="info_list_item_tu" v-if="info">
							<view class="info_list_item_tu_img" v-for="(item, index) in info.otherFileList" :key="index">
								<!-- <view class="info_list_item_tu_img_dele" @click.stop="deleFile(item.id, item.objId)">
									<image src="@/static/icon/ic_delete@2x.png" mode="widthFix"></image>
								</view> -->
								<image :src="item.fileurlFull" mode="widthFix" v-if="item.type === 0"></image>
								<video :src="item.fileurlFull" v-if="item.type === 1"></video>
							</view>
							<view class="info_list_item_tu_up" @click="upload(6)" v-if="info.status == 0 || info.status == 2 || info.status == 3">
								<u-icon name="plus" color="#222222" size="20"></u-icon>
							</view>
							<view class="info_list_item_tu_zw"></view>
							<view class="info_list_item_tu_zw"></view>
							<view class="info_list_item_tu_zw"></view>
						</view>
						<view class="info_list_item f">
							<view class="info_list_item_label1">补充材料</view>
							<view class="info_list_item_tu" v-if="info">
								<view class="info_list_item_tu_img" v-for="(item, index) in info.supplementFileList" :key="index">
									<!-- <view class="info_list_item_tu_img_dele" @click.stop="deleFile(item.id, item.objId)">
										<image src="@/static/icon/ic_delete@2x.png" mode="widthFix"></image>
									</view> -->
									<image :src="item.fileurlFull" mode="widthFix" v-if="item.type === 0"></image>
									<video :src="item.fileurlFull" v-if="item.type === 1"></video>
								</view>
								<view class="info_list_item_tu_up" @click="upload(6)" v-if="info.status == 0 || info.status == 2 || info.status == 3">
									<u-icon name="plus" color="#222222" size="20"></u-icon>
								</view>
								<view class="info_list_item_tu_zw"></view>
								<view class="info_list_item_tu_zw"></view>
								<view class="info_list_item_tu_zw"></view>
							</view>
						</view>
					</view>
				</view>
			</view>
			<view class="box_head_infoA" :style="{ height: height2 }">
				<view class="box_head_info_title" @click="open(3)">
					<view class="title">案件进度</view>
					<view class="rowwle">
						<text>{{height2 === 'auto' ? '收起' : '展开'}}</text>
						<image :style="{transform: height2 === 'auto' ? '' : 'rotate(180deg)'}" src="@/static/icon/ic_close@2x.png" mode="widthFix"></image>
					</view>
				</view>
				<view class="info_list" v-if="info && info.settleClaimsLogList">
					<view class="info_list_row" v-for="(item, index) in info.settleClaimsLogList" :key="index">
						<view class="info_list_row_xian">
							<view class="info_list_row_xian_d">
								<view class="info_list_row_xian_d_y"></view>
							</view>
							<view class="info_list_row_xian_h" v-if="info.settleClaimsLogList.length - 1 !== index"></view>
						</view>
						<view class="info_list_row_info">
							<view class="info_list_row_info_top">
								<text :style="{ color: info.settleClaimsLogList.length - 1 === index ? '#437CB3' : '' }">{{item.title}}</text>
								<text>{{item.createDate}}</text>
							</view>
							<view class="info_list_row_info_bottom">
								操作员：{{item.creatorName}}（{{item.creatorType == 1 ? item.companyName : "平台端"}}）
							</view>
							<view class="info_list_row_info_nr" v-if="item.content">
								<view class="info_list_row_info_nr_title" :style="{ color: info.settleClaimsLogList.length - 1 === index ? '#437CB3' : '' }">处理进展：</view>
								<view class="info_list_row_info_nr_val">
									<text>{{item.content}}</text>
									<text v-if="item.objType === 3">医疗理赔:{{JSON.parse(item.afterContent).ylClaimAccount}}元，误工理赔:{{JSON.parse(item.afterContent).wgClaimAccount}}元，伤残理赔:{{JSON.parse(item.afterContent).scClaimAccount}}元，死亡理赔:{{JSON.parse(item.afterContent).swClaimAccount}}元，理赔总额:{{JSON.parse(item.afterContent).claimAccount}}元。</text>
								</view>
							</view>
						</view>
					</view>
				</view>
			</view>
			<view style="width: 100%; height: calc(env(safe-area-inset-bottom) + 120rpx);"></view>
			<view class="details_footer">
				<u-button type="primary" shape="circle" color="#437CB3" plain text="撤销报案" v-if="[1,2,3,4,5,9,7,10].includes(info.status)"></u-button>
				<view style="width: 30rpx; height: 100%;" v-if="([9].includes(info.status) && info.waitSupplement === 1) || [1,2,4,5,7].includes(info.status)"></view>
				<u-button type="primary" shape="circle" color="#437CB3" text="补充材料" @click="show = true" v-if="[9].includes(info.status) && info.waitSupplement === 1"></u-button>
				<u-button type="primary" shape="circle" color="#437CB3" text="修改" @click="edit" v-if="[1,2,4,5,7].includes(info.status)"></u-button>
			</view>
		</view>
		<u-modal
			title="补充材料"
			:show="show"
			:showCancelButton="true"
			closeOnClickOverlay
			@cancel="show = false"
			@confirm="confirm"
		>
			<view class="meade">
				<view class="meade_content" v-for="(item,index) in fileList" :key="index">
					<image class="dele" src="@/static/icon/ic_delete@2x.png" mode="widthFix" @click="deletePic(index, 6)"></image>
					<image class="image" :src="item.fileurlFull" mode="widthFix" v-if="item.type === 0"></image>
					<video class="video" :src="item.fileurlFull" controls v-if="item.type === 1"></video>
				</view>
				<view class="meade_upload" @click="upload()">
					<u-icon name="plus" color="#999999" size="20"></u-icon>
					<text>点击上传</text>
				</view>
				<view class="meade_zw"></view>
				<view class="meade_zw"></view>
				<view class="meade_zw"></view>
			</view>
		</u-modal>
		<!-- 确认金额弹窗提示 -->
		<u-modal
			:show="show1"
			showCancelButton
			title="系统提醒"
			content='是否确认赔付金额?'
			@confirm="confirmPrice"
			@cancel="show1 = false" />
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		data() {
			return {
				id: null,
				info: null,
				show: false,
				show1: false,
				height: 'auto',
				height1: 'auto',
				height2: 'auto',
				fileList: []
			};
		},
		onLoad(option) {
			this.id = option.id
			this.getDetails()
			uni.$on('update', (data) => {
				this.getDetails()
			})
		},
		computed: {
			...mapState(['cookies'])
		},
		methods: {
			queren() {
				this.show1 = true
			},
			confirmPrice() {
				this.$u.api.confirmFee(this.id)
					.then(res => {
						this.show1 = false
						this.getDetails()
					})
			},
			upload(type) {
				var that = this
				uni.chooseMedia({
					count: 9,
					mediaType: ['image','video'],
					sourceType: ['album', 'camera'],
					camera: 'back',
					success(res) {
						uni.showLoading({ title: '上传中', mask: true });
						for (let i = 0; i < res.tempFiles.length; i++) {
							uni.uploadFile({
								url: `${that.$baseUrl}public/upload`,
								filePath: res.tempFiles[i].tempFilePath,
								name: 'file',
								header: {
									'doumee-auth-token': that.$store.state.cookies
								},
								formData: {
									folder: 'settle'
								},
								success: (uploadFileRes) => {
									let res = JSON.parse(uploadFileRes.data)
									that.fileList.push({
										fileurl: res.data.imgaddr,
										name: res.data.originname,
										type: res.data.type,
										fileurlFull: res.data.url
									})
								},
								complete() {
									if (i === res.tempFiles.length - 1) {
										uni.hideLoading();
									}
								}
							});
						}
					}
				})
			},
			jumpD() {
				uni.navigateTo({
					url: `/pages/compensationDetails/compensationDetails?id=${this.id}`
				})
			},
			returnInHospital (type) {
				switch (type) {
					case 0:
						return '住院'
					case 1:
						return '门诊'
				}
			},
			returnName (type) {
			      switch (type) {
			      case 0:
			        return '是'
			      case 1:
			        return '否'
			      case 2:
			        return '待确定'
			      default:
			        return ''
			      }
			    },
			// 删除附件
			deleFile(id, objId) {
				this.$u.api.delFile(objId, id)
					.then(res => {
						if (res.code === 200) {
							this.getDetails()
						}
					})
			},
			// // 上传材料
			// upload(type) {
			// 	var that = this
			// 	uni.chooseMedia({
			// 		count: 1,
			// 		maxDuration: 60,
			// 		success(res) {
			// 			uni.uploadFile({
			// 				url: that.$baseUrl + 'public/upload',
			// 				filePath: res.tempFiles[0].tempFilePath,
			// 				name: 'file',
			// 				header: {
			// 					'doumee-auth-token': that.cookies
			// 				},
			// 				formData: {
			// 					'folder': 'settle'
			// 				},
			// 				success: (uploadFileRes) => {
			// 					let data = JSON.parse(uploadFileRes.data).data
			// 					console.log(JSON.parse(uploadFileRes.data).data)
			// 					that.$u.api.claimsUploadFile({
			// 						fileName: '',
			// 						fileType: data.type,
			// 						fileUrl: data.imgaddr,
			// 						id: that.id,
			// 						objType: type
			// 					}).then(result => {
			// 						that.getDetails()
			// 					})
			// 				}
			// 			});
			// 		}
			// 	})
			// },
			openBC() {
				this.value = ''
				this.show = true
			},
			confirm() {
				if (this.fileList.length === 0) return uni.showToast({
					title: '请先上传材料',
					icon: 'none'
				})
				this.$u.api.saveSupplementFile({
					id: this.id,
					supplementFileList: this.fileList
				}).then(res => {
					if (res.code === 200) {
						this.show = false
						this.getDetails()
					}
				})
			},
			edit() {
				uni.navigateTo({
					url: `/pages/new_report/new_report?id=${this.info.id}`
				})
			},
			getDetails() {
				this.$u.api.settleClaimsById(this.id)
					.then(res => {
						if (res.code === 200) {
							this.info = res.data
						}
					})
			},
			open(type) {
				if (type === 1) {
					if (this.height === '104rpx') {
						this.height = 'auto'
					} else {
						this.height = '104rpx'
					}
				} else if (type === 2) {
					if (this.height1 === '104rpx') {
						this.height1 = 'auto'
					} else {
						this.height1 = '104rpx'
					}
				} else {
					if (this.height2 === '104rpx') {
						this.height2 = 'auto'
					} else {
						this.height2 = '104rpx'
					}
				}
			}
		}
	}
</script>
<style>
	page {
		background-color: #f7f7f7;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.meade {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-around;
			flex-wrap: wrap;
			.meade_zw {
				width: 140rpx;
				height: 0;
			}
			.meade_content {
				width: 140rpx;
				height: 140rpx;
				display: flex;
				align-items: center;
				justify-content: center;
				overflow: hidden;
				position: relative;
				.video {
					width: 100%;
				}
				.dele {
					width: 50rpx;
					height: 50rpx;
					position: absolute;
					top: 0;
					right: 0;
					z-index: 9;
				}
				.image {
					width: 100%;
				}
			}
			.meade_upload {
				width: 140rpx;
				height: 140rpx;
				background: #FFFFFF;
				border-radius: 8rpx;
				border: 1rpx solid #E5E5E5;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				text {
					font-weight: 400;
					font-size: 24rpx;
					color: #666666;
					font-style: normal;
					margin-top: 5rpx;
				}
			}
		}
		.box_head {
			width: 100%;
			height: 240rpx;
			padding: 30rpx;
			box-sizing: border-box;
			background: linear-gradient( 180deg, #437CB3 0%, #F7F7F7 100%);
			.box_head_info {
				width: 100%;
				padding: 32rpx 30rpx;
				box-sizing: border-box;
				background-color: rgba(255, 255, 255, 0.7);
				border-radius: 16rpx;
				position: relative;
				.yellow {
					background-color: #FF971D !important;
				}
				.info {
					background-color: #CCCCCC !important;
				}
				.status {
					position: absolute;
					top: 0;
					right: 0;
					padding: 0 20rpx;
					box-sizing: border-box;
					height: 52rpx;
					line-height: 52rpx;
					text-align: center;
					background: #FF971D;
					font-weight: 400;
					font-size: 26rpx;
					color: #FFFFFF;
					font-style: normal;
					border-radius: 0rpx 16rpx 0rpx 32rpx;
				}
				.box_head_info_title {
					font-weight: 500;
					font-size: 40rpx;
					color: #222222;
					font-style: normal;
				}
				.box_head_info_list {
					width: 100%;
					margin-top: 24rpx;
					position: relative;
					image {
						width: 200rpx;
						height: 202rpx;
						position: absolute;
						bottom: 0;
						right: 0;
					}
					.box_head_info_list_item {
						width: 100%;
						display: flex;
						align-items: center;
						margin-bottom: 20rpx;
						&:last-child {
							margin: 0 !important;
						}
						.label {
							font-weight: 400;
							font-size: 26rpx;
							color: #777777;
							font-style: normal;
						}
						.value {
							font-weight: 400;
							font-size: 26rpx;
							color: #222222;
							font-style: normal;
						}
					}
				}
			}
			.details_footer {
				width: 100%;
				position: fixed;
				bottom: 0;
				left: 0;
				z-index: 99;
				padding: 10rpx 30rpx calc(env(safe-area-inset-bottom) + 10rpx) 30rpx;
				box-sizing: border-box;
				background-color: #ffffff;
				display: flex;
				align-items: center;
			}
			.box_dakuan {
				width: 100%;
				padding: 30rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 16rpx;
				margin-top: 20rpx;
				.box_dakuan_head {
					width: 100%;
					display: flex;
					align-items: center;
					image {
						width: 36rpx;
						height: 36rpx;
						margin-right: 16rpx;
					}
					text {
						font-weight: 500;
						font-size: 32rpx;
						color: #222222;
					}
				}
				.box_dakuan_list {
					width: 100%;
					margin-top: 38rpx;
					.box_dakuan_list_row {
						width: 100%;
						display: flex;
						align-items: center;
						margin-bottom: 20rpx;
						&:last-child {
							margin: 0 !important;
						}
						.box_dakuan_list_row_label {
							width: 120rpx;
							flex-shrink: 0;
							margin-right: 30rpx;
							font-weight: 400;
							font-size: 26rpx;
							color: #777777;
						}
						.box_dakuan_list_row_val {
							flex: 1;
							text-align: right;
							font-weight: 400;
							font-size: 26rpx;
							color: #222222;
						}
						.box_dakuan_list_row_list {
							flex: 1;
							display: flex;
							align-items: center;
							flex-wrap: wrap;
							.box_dakuan_list_row_list_image {
								width: 140rpx;
								height: 140rpx;
								border-radius: 16rpx;
								display: flex;
								align-items: center;
								justify-content: center;
								overflow: hidden;
								margin-left: 20rpx;
								margin-bottom: 20rpx;
								&:first-child {
									margin: 0 !important;
								}
								image {
									width: 100%;
									height: 100%;
								}
							}
						}
					}
				}
			}
			.box_jine {
				width: 100%;
				padding: 30rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 16rpx;
				margin-top: 20rpx;
				.box_jine_head {
					width: 100%;
					display: flex;
					align-items: center;
					margin-bottom: 30rpx;
					image {
						width: 36rpx;
						height: 36rpx;
						margin-right: 16rpx;
					}
					text {
						font-weight: 500;
						font-size: 32rpx;
						color: #222222;
					}
				}
				.box_jine_nr {
					width: 100%;
					padding: 26rpx 20rpx;
					box-sizing: border-box;
					background: rgba(255,151,29,0.1);
					border-radius: 8rpx;
					.box_jine_nr_head {
						width: 100%;
						display: flex;
						align-items: center;
						margin-bottom: 16rpx;
						image {
							width: 32rpx;
							height: 32rpx;
							margin-right: 16rpx;
						}
						text {
							font-weight: 500;
							font-size: 30rpx;
							color: #222222;
						}
					}
					.box_jine_nr_list {
						width: 100%;
						display: flex;
						flex-direction: column;
						text {
							font-weight: 400;
							font-size: 26rpx;
							color: #222222;
						}
					}
				}
				.box_jine_price {
					font-weight: bold;
					font-size: 52rpx;
					color: #FF2828;
					margin-top: 30rpx;
				}
				.box_jine_pf {
					margin-top: 30rpx;
					display: flex;
					align-items: center;
					text {
						font-weight: 400;
						font-size: 26rpx;
						color: #437CB3;
						margin-right: 14rpx;
					}
				}
				.box_jine_x {
					width: 100%;
					height: 1rpx;
					margin-top: 30rpx;
					background-color: #E5E5E5;
				}
				.box_jine_submit {
					margin-top: 38rpx;
					width: 100%;
					font-weight: 600;
					font-size: 32rpx;
					color: #FF2828;
					text-align: center;
				}
			}
			.box_tuihui {
				width: 100%;
				padding: 30rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 16rpx;
				margin-top: 20rpx;
				.box_tuihui_label {
					width: 100%;
					font-weight: 500;
					font-size: 32rpx;
					color: #222222;
					margin-bottom: 30rpx;
					margin-right: 20rpx;
					display: flex;
					align-items: center;
					justify-content: space-between;
					text {
						font-weight: 400;
						font-size: 28rpx;
						color: #437CB3;
					}
				}
				.box_tuihui_list {
					width: 100%;
					.box_tuihui_list_row {
						width: 100%;
						display: flex;
						align-items: center;
						margin-bottom: 20rpx;
						&:last-child {
							margin: 0 !important;
						}
						.box_tuihui_list_row_label {
							width: 150rpx;
							font-weight: 400;
							font-size: 26rpx;
							color: #777777;
							flex-shrink: 0;
						}
						.box_tuihui_list_row_val {
							flex: 1;
							text-align: right;
							font-weight: 400;
							font-size: 26rpx;
							color: #222222;
						}
					}
				}
			}
			.box_head_infoA {
				width: 100%;
				padding: 30rpx;
				box-sizing: border-box;
				overflow: hidden;
				margin-top: 30rpx;
				background: #FFFFFF;
				border-radius: 16rpx;
				.info_list {
					width: 100%;
					margin-top: 30rpx;
					overflow: hidden;
					.info_list_row {
						width: 100%;
						min-height: 80rpx;
						display: flex;
						align-items: flex-start;
						margin-bottom: 40rpx;
						&:last-child {
							margin: 0 !important;
						}
						.info_list_row_xian {
							flex-shrink: 0;
							width: 20rpx;
							min-height: 80rpx;
							margin-right: 20rpx;
							position: relative;
							.info_list_row_xian_d {
								width: 28rpx;
								height: 28rpx;
								border-radius: 50%;
								padding: 4rpx;
								box-sizing: border-box;
								background-color: #ffffff;
								border: 2rpx solid #999999;
								position: relative;
								z-index: 9;
								.info_list_row_xian_d_y {
									width: 100%;
									height: 100%;
									border-radius: 50%;
									background: #999999;
								}
							}
							.info_list_row_xian_h {
								width: 2rpx;
								height: calc(100% + 45rpx);
								position: absolute;
								top: 0;
								left: 12rpx;
								background-color: #CCCCCC;
							}
						}
						.info_list_row_info {
							flex: 1;
							display: flex;
							flex-direction: column;
							.info_list_row_info_top {
								width: 100%;
								display: flex;
								align-items: center;
								justify-content: space-between;
								text {
									&:nth-child(1) {
										font-weight: 500;
										font-size: 30rpx;
										color: #333333;
										font-style: normal;
									}
									&:nth-child(2) {
										font-weight: 400;
										font-size: 26rpx;
										color: #999999;
										font-style: normal;
									}
								}
							}
							.info_list_row_info_bottom {
								width: 100%;
								margin-top: 14rpx;
								font-weight: 400;
								font-size: 26rpx;
								color: #999999;
								font-style: normal;
							}
							.info_list_row_info_nr {
								width: 100%;
								padding: 24rpx;
								box-sizing: border-box;
								background: #F7F7F7;
								border-radius: 16rpx;
								display: flex;
								flex-direction: column;
								margin-top: 20rpx;
								.info_list_row_info_nr_title {
									font-weight: 500;
									font-size: 26rpx;
									color: #666666;
									font-style: normal;
								}
								.info_list_row_info_nr_val {
									display: flex;
									flex-direction: column;
									margin-top: 12rpx;
									text {
										font-weight: 400;
										font-size: 26rpx;
										color: #666666;
										font-style: normal;
										margin-bottom: 20rpx;
										&:last-child {
											margin: 0 !important;
										}
									}
								}
							}
						}
					}
					.f {
						display: flex !important;
						flex-direction: column !important;
					}
					.info_list_item {
						width: 100%;
						display: flex;
						align-items: flex-start;
						justify-content: space-between;
						margin-bottom: 20rpx;
						&:last-child {
							margin: 0 !important;
						}
						.info_list_item_tu {
							width: 100%;
							margin-top: 20rpx;
							display: flex;
							align-items: center;
							justify-content: space-between;
							flex-wrap: wrap;
							.info_list_item_tu_zw {
								width: 140rpx;
								height: 0;
							}
							.info_list_item_tu_up {
								width: 140rpx;
								height: 140rpx;
								border-radius: 15rpx;
								margin-bottom: 20rpx;
								display: flex;
								align-items: center;
								justify-content: center;
								border: 1rpx solid #999999;
							}
							.info_list_item_tu_img {
								width: 140rpx;
								height: 140rpx;
								border-radius: 15rpx;
								margin-bottom: 20rpx;
								display: flex;
								align-items: center;
								justify-content: center;
								overflow: hidden;
								position: relative;
								.info_list_item_tu_img_dele {
									width: 50rpx;
									height: 50rpx;
									position: absolute;
									right: 0;
									top: 0;
									z-index: 9;
								}
								image {
									width: 100%;
									height: 100%;
								}
								video {
									height: 100%;
								}
							}
						}
						.info_list_item_label1 {
							width: 100%;
							font-weight: 400;
							font-size: 26rpx;
							color: #777777;
							font-style: normal;
						}
						.info_list_item_label {
							width: 200rpx;
							flex-shrink: 0;
							font-weight: 400;
							font-size: 26rpx;
							color: #777777;
							font-style: normal;
						}
						.info_list_item_val {
							font-weight: 400;
							font-size: 26rpx;
							color: #222222;
							font-style: normal;
						}
					}
				}
				.box_head_info_title {
					width: 100%;
					height: 44rpx;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.title {
						font-weight: 500;
						font-size: 32rpx;
						color: #222222;
						font-style: normal;
					}
					.rowwle {
						display: flex;
						align-items: center;
						text {
							font-weight: 400;
							font-size: 26rpx;
							color: #999999;
							font-style: normal;
						}
						image {
							width: 22rpx;
							height: 12rpx;
							margin-left: 8rpx;
						}
					}
				}
			}
		}
	}
</style>
